import { Toaster } from "sonner";
import { useTheme } from "next-themes";

export function ThemeAwareToaster() {
  const { theme } = useTheme();
  const resolvedTheme = (theme as "light" | "dark" | "system") || "system";

  return (
    <>
      <div className="block sm:hidden [&_[data-sonner-toaster]]:!w-fit [&_[data-sonner-toaster]]:!min-w-[250px] [&_[data-sonner-toaster]]:!max-w-[85vw] [&_[data-sonner-toaster]]:!left-1/2 [&_[data-sonner-toaster]]:!-translate-x-1/2 [&_[data-sonner-toaster]]:!right-auto [&_[data-sonner-toast]]:!w-fit [&_[data-sonner-toast]]:!min-w-[250px] [&_[data-sonner-toast]]:!max-w-[85vw]">
        <Toaster
          richColors
          theme={resolvedTheme}
          visibleToasts={3}
          position="top-center"
          toastOptions={{
            className:
              "!py-3 !px-3 !text-xs !gap-1 [&_[data-content]]:!truncate [&_[data-title]]:!truncate",
          }}
        />
      </div>
      <div className="hidden sm:block">
        <Toaster
          richColors
          theme={resolvedTheme}
          visibleToasts={6}
          position="bottom-center"
        />
      </div>
    </>
  );
}
